import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../../services/validation.service';
import { CookieService } from 'ngx-cookie-service';
import { PagerService } from '../../../services/index';
import { Session } from 'protractor';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;
declare var $:any;


@Component({
  selector: 'app-society-user-survey',
  templateUrl: './society-user-survey.component.html',
  styleUrls: ['./society-user-survey.component.css']
})
export class SocietyUserSurveyComponent implements OnInit {
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	userName: any;
	email: any;
	phone: any;
	surveyList: any;
	selectedUserId :any;
	profileImage:any;
	prevUrl:any;
	is_from_group=false;
	is_group_survey_report = false;
	id:any;
	deleteSelectedSurveyData: any;
	//getUserList:[];
	constructor(private validationService: ValidationService, private authService: AuthService, private commonService: CommonService,
		private cookieService: CookieService, private router: Router, private pagerService: PagerService, private activatedRoute: ActivatedRoute) {
	}

	ngOnInit() {
		this.commonService.process();
		this.activatedRoute.params.subscribe((params: any) => {
		        // debugger;;
			if (params.user_id) {
			
				this.selectedUserId = params.user_id;
				this.prevUrl = params.prev_token;
				this.is_from_group = params.prev_token.indexOf('groupList') >-1 ? true : false;
				this.pager = 1;
				this.limit = 10;
				
				this.getSelectedUserSurvey(this.pager,this.limit,this.selectedUserId);
			}
		});
		
	
	}
	getGroupMembersList = function (pageNo, limit) {
		this.commonService.process();
		
		this.authService.getGroupMembersList(pageNo, limit, this.group_id).subscribe(data => {
			if (data.success) {
				
				var that = this;
				if (pageNo == this.activePageNo)
					setTimeout(function () {
						//jQuery("#search").val(that.searchStr);
						jQuery('#page_' + that.activePageNo).addClass('active');
						if (that.activePageNo == 1)
							jQuery('#first, #prev').addClass('disabled');
						else if (that.activePageNo == that.pager.totalPages)
							jQuery('#next, #last').addClass('disabled');
					}, 300);
				this.groupMemberList = data.members;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				this.redirectUrl = 'pageNo=1&groupList=1';
			}
			else {
				this.isUserAvailable = false;
				this.userList = [];
			}
			this.commonService.hideProcess();
		});
	}
	// Get selected user survey
	getSelectedUserSurvey = function (pageNo, limit, userId) {
		
		this.commonService.process();
		this.authService.getSelectedUserSurvey(pageNo, limit, userId).subscribe(data => {
			if (data.success) {
				
				this.surveyList = data.survey;
				this.total = data.total;
				this.profileImage = this.commonService.imageUrl + this.surveyList[0].user_id.profile_pic;
				this.userName = this.surveyList[0].user_id.name;
				$(".navbar-brand").html(this.userName + '\'s Profile');
				this.email = this.surveyList[0].user_id.email;
				this.phone = this.surveyList[0].user_id.phone;
				this.id = userId;
				
				this.setPage(pageNo, true);
			}
			else{
				this.authService.getUserProfile(userId).subscribe(data => {
					if (data.success) {
						this.profileImage = this.commonService.imageUrl + data.user.profile_pic;
						this.userName = data.user.name;
						$(".navbar-brand").html(this.userName + '\'s Profile');
						this.email = data.user.email;
						this.phone = data.user.phone;
					}
				});
			}
			this.commonService.hideProcess();
		});
	}
	// // Delete selected Survey Details
	// deleteSelectedSurvey = function (survey) {
		
	// 	this.isDeleteSurvey = true;
	// 	this.deleteSelectedSurveyData = survey
	// }
	// // Delete Survey
	// deleteSurvey = function (id) {
	// 	this.authService.deleteSurveyComment(id).subscribe(data => {
	// 		if (data.success) {
	// 			this.authService.cancelProcess();
	// 			this.getSurveyList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
	// 			jQuery.growl.notice({ title: 'Success', message: data.message });
	// 		}
	// 		else {
	// 			jQuery.growl.error({ title: 'Error', message: data.error });
	// 		}
	// 	});
	// }
// // show button
// showDeleteButton = function () {        // debugger;;
// 	$("#butDelete").show;
// }
	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getSelectedUserSurvey(page, this.limit, this.selectedUserId);
		}
	}
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/society-user-survey/society-user-survey/society-user-survey.component.ts